<template>
    <div class="vx-row flex">
        <div class="vx-col xl:w-1/12 lg:w-2/12 w-full mb-3">
            <vx-card>
                <div class="w-full flex justify-center" id="getDataDiv">
                    <vs-button class="mt-2 mr-3" type="border" size="large" icon-pack="feather" icon="icon-refresh-cw" color="success" @click="loadData()" ></vs-button>
                    <vs-button class="mt-2" type="border" size="large" icon-pack="feather" icon="icon-x-circle" color="danger" @click="clearOptions()" ></vs-button>
                </div>
            </vx-card>
        </div>
        <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4 mb-3">
            <statistics-card-line
                    hideChart
                    icon="CheckCircleIcon"
                    icon-right
                    :statistic="this.totalTime"
                    color="success"
                    :statisticTitle='$t("AnalyticsTotalTime")' />
        </div>
        <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4 mb-3">
            <statistics-card-line
                    v-if="this.gridApi"
                    hideChart
                    icon="XCircleIcon"
                    icon-right
                    :statistic="this.nonInvoicedTime"
                    color="danger"
                    :statisticTitle='$t("AnalyticsNonInvoicedTime")' />
        </div>
        <div class="vx-col w-full mb-3">
            <vx-card :title='$t("Settings")'>
                <div class="vx-row">
                    <div class="vx-col xl:w-1/6 lg:w-1/6 md:w-1/4 w-1/2 mb-3">
                        <p >{{$t("StartTime")}}</p>
                        <flat-pickr class="w-full" :config="configDateTimePicker" v-model="reqOptions['start_time']"/>
                    </div>
                    <div class="vx-col xl:w-1/6 lg:w-1/6 md:w-1/4 w-1/2 mb-3">
                        <p>{{$t("EndTime")}}</p>
                        <flat-pickr class="w-full" :config="configDateTimePicker" v-model="reqOptions['end_time']"/>
                    </div>
                    <div class="vx-col xl:w-1/6 lg:w-1/6 md:w-1/4 w-1/2 mb-3">
                        <p>{{$t("Projects")}}</p>
                        <vs-select autocomplete class="selectExample w-full" v-model="reqOptions['projects']">
                            <vs-select-item :key="index" :value="item.id" :text="item.name" v-for="(item,index) in [{id:0, name:$t('Yes')}, {id:1, name:$t('No')}, {id:2, name:$t('OnlyProjects')}]" />
                        </vs-select>
                    </div>
                    <div class="vx-col xl:w-1/6 lg:w-1/6 md:w-1/4 w-1/2 mb-3">
                        <vs-button class="mt-5 w-full" type="border" icon-pack="feather" icon="icon-tag" color="dark" @click="activePickTagsPrompt = true" >{{$t('Tags')}}</vs-button>
                    </div>
                    <div class="vx-col xl:w-1/6 lg:w-1/6 md:w-1/4 w-1/2 mb-3">
                        <vs-button class="mt-5 w-full" type="border" icon-pack="feather" icon="icon-users" color="dark" @click="activeSelectUsersPrompt = true" >{{$t('Users')}}</vs-button>
                    </div>
                    <div class="vx-col xl:w-1/6 lg:w-1/6 md:w-1/4 w-1/2 mb-3">
                        <vs-button class="mt-5 w-full" type="border" icon-pack="feather" icon="icon-home" color="dark" @click="activeSelectClientsPrompt = true" >{{$t('Clients')}}</vs-button>
                    </div>
                </div>
            </vx-card>
        </div>
        <div class="vx-col w-full mb-3">
            <vx-card :title='$t("Data")'>

                <div class="flex flex-wrap justify-between items-center">

                    <!-- ITEMS PER PAGE -->
                    <div class="mb-4 md:mb-0 mr-4 ag-grid-table-actions-left">

                        <vs-dropdown v-if="this.gridApi" vs-trigger-click class="cursor-pointer">
                            <div class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
                                <span class="mr-2">{{ currentPage * paginationPageSize - (paginationPageSize - 1) }} - {{ gridApi.getDisplayedRowCount() - currentPage * paginationPageSize > 0 ? currentPage * paginationPageSize : gridApi.getDisplayedRowCount() }} of {{ gridApi.getDisplayedRowCount() }}</span>
                                <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
                            </div>

                            <!-- <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button> -->
                            <vs-dropdown-menu>

                                <vs-dropdown-item @click="gridApi.paginationSetPageSize(10)">
                                    <span>10</span>
                                </vs-dropdown-item>
                                <vs-dropdown-item @click="gridApi.paginationSetPageSize(20)">
                                    <span>20</span>
                                </vs-dropdown-item>
                                <vs-dropdown-item @click="gridApi.paginationSetPageSize(50)">
                                    <span>50</span>
                                </vs-dropdown-item>
                                <vs-dropdown-item @click="gridApi.paginationSetPageSize(100)">
                                    <span>100</span>
                                </vs-dropdown-item>
                                <vs-dropdown-item @click="gridApi.paginationSetPageSize(150)">
                                    <span>150</span>
                                </vs-dropdown-item>
                                <vs-dropdown-item @click="gridApi.paginationSetPageSize(200)">
                                    <span>200</span>
                                </vs-dropdown-item>
                                <vs-dropdown-item @click="gridApi.paginationSetPageSize(300)">
                                    <span>300</span>
                                </vs-dropdown-item>
                                <vs-dropdown-item @click="gridApi.paginationSetPageSize(500)">
                                    <span>500</span>
                                </vs-dropdown-item>
                            </vs-dropdown-menu>
                        </vs-dropdown>


                    </div>


                    <!-- TABLE ACTION COL-2: SEARCH & EXPORT AS CSV -->
                    <div class="flex flex-wrap items-center justify-between ag-grid-table-actions-right">
                        <vs-input class="mb-4 md:mb-0 mr-4" v-model="searchQuery" @input="updateSearchQuery" placeholder="Search..." />
                        <vx-tooltip :text="$t('ExpandColumns')" delay=".5s">
                            <vs-button class="ml-3" type="border" color="success" @click="resizeColumns" icon-pack="feather" icon="icon-maximize-2"/>
                        </vx-tooltip>
                        <vx-tooltip :text="$t('ClearFilters')" delay=".5s">
                            <vs-button class="ml-3" type="border" color="danger" @click="clearFilters" icon-pack="feather" icon="icon-x-circle"/>
                        </vx-tooltip>
                    </div>
                </div>

                <ag-grid-vue
                        ref="agGridTable"
                        :gridOptions="gridOptions"
                        class="ag-theme-material w-100 my-4 ag-grid-table"
                        :columnDefs="columnDefs"
                        :defaultColDef="defaultColDef"
                        :rowData="times"
                        rowSelection="multiple"
                        :animateRows="true"
                        domLayout="autoHeight"
                        :floatingFilter="true"
                        :pagination="true"
                        :paginationPageSize="paginationPageSize"
                        :suppressPaginationPanel="true">
                </ag-grid-vue>
                <vs-pagination
                        :total="totalPages"
                        :max="maxPageNumbers"
                        v-model="currentPage" />

            </vx-card>
        </div>
        <div class="vx-col w-full flex mb-3" v-if="perUserGraphData.length > 0">
            <vx-card :title="$t('TimeByUser')">
                <vue-apex-charts type=bar :height="perUserGraphHeight" :options="perUserGraphOptions" :series="perUserGraphData" />
            </vx-card>
        </div>
        <div class="vx-col w-full flex" v-if="perClientGraphData.length > 0">
            <vx-card :title="$t('TimeByClient')">
                <vue-apex-charts type=bar :height="perClientGraphHeight" :options="perClientGraphOptions" :series="perClientGraphData" />
            </vx-card>
        </div>

        <vs-popup v-if="this.$store.state.tagsArray" :title="$t('Tags')" :active.sync="activePickTagsPrompt">
            <vx-card>
                <vs-table ref="table" v-model="selectedTags" multiple search :data="this.$store.state.tagsArray">

                    <template slot="header">
                        <vs-checkbox class="mt-6 mb-6" v-model="reqOptions['untagged']">{{$t("Untagged")}}</vs-checkbox>
                    </template>

                    <template slot="thead">
                        <vs-th sort-key="name">{{$t("Name")}}</vs-th>
                    </template>

                    <template slot-scope="{data}">
                        <tbody>
                        <vs-tr :data="tr" :key="index" v-for="(tr, index) in data">

                            <vs-td :data="data[index].name">
                                <vs-chip class="mr-3" :color="data[index].color">
                                    <p v-bind:style="{color: data[index].text_color}"><b>{{ data[index].name}}</b></p>
                                </vs-chip>
                            </vs-td>
                        </vs-tr>
                        </tbody>
                    </template>

                </vs-table>
            </vx-card>
        </vs-popup>

        <vs-popup v-if="usersArray" :title="$t('Users')" :active.sync="activeSelectUsersPrompt">
            <vx-card>
                <vs-table ref="table" v-model="selectedUsers" multiple search :data="usersArray">

                    <template slot="thead">
                        <vs-th sort-key="name">{{$t("Name")}}</vs-th>
                    </template>

                    <template slot-scope="{data}">
                        <tbody>
                        <vs-tr :data="tr" :key="index" v-for="(tr, index) in data">

                            <vs-td :data="data[index].name">
                                {{ data[index].name}}
                            </vs-td>
                        </vs-tr>
                        </tbody>
                    </template>

                </vs-table>
            </vx-card>
        </vs-popup>

        <vs-popup v-if="clientsArray" :title="$t('Users')" :active.sync="activeSelectClientsPrompt">
            <vx-card>
                <vs-table ref="table" v-model="selectedClients" multiple search :data="clientsArray">

                    <template slot="thead">
                        <vs-th sort-key="name">{{$t("Name")}}</vs-th>
                    </template>

                    <template slot-scope="{data}">
                        <tbody>
                        <vs-tr :data="tr" :key="index" v-for="(tr, index) in data">

                            <vs-td :data="data[index].name">
                                {{ data[index].name}}
                            </vs-td>
                        </vs-tr>
                        </tbody>
                    </template>

                </vs-table>
            </vx-card>
        </vs-popup>
    </div>
</template>
<script>

    import { AgGridVue } from "ag-grid-vue"
    import '@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss'

    import flatPickr from 'vue-flatpickr-component';
    import 'flatpickr/dist/flatpickr.css';
    import StatisticsCardLine from '@/components/statistics-cards/StatisticsCardLine.vue'
    import TaskNameRenderer from "./TaskNameRenderer";
    import TimeRenderer from "../Task/TimeRenderer";
    import VueApexCharts from 'vue-apexcharts'

    export default {
        name: 'TimeAnalytics',
        components: {
            flatPickr,
            StatisticsCardLine,
            AgGridVue,
            TimeRenderer,
            VueApexCharts
        },
        data() {
            return {

                times: [],

                reqOptions: {
                    start_time: null,
                    end_time: null,
                    projects: 0,
                    untagged: true
                },

                configDateTimePicker: {
                    dateFormat: 'Y-m-d',
                    locale: {
                        firstDayOfWeek: 1
                    }
                },

                activePickTagsPrompt: false,

                selectedTags: [],

                activeSelectUsersPrompt: false,
                selectedUsers: [],

                activeSelectClientsPrompt: false,
                selectedClients: [],


                searchQuery: '',
                gridOptions: {
                    suppressRowClickSelection: true,
                    onCellClicked: (e) => {
                        if (e.column.colId === 'task_title' || e.column.colId === 'company_task_id') {
                            this.$router.push({ name: 'task', params: { id: "" + e.data.task_id } })
                        }else if (e.column.colId === 'client_company') {
                            this.$router.push({ name: 'client', params: { id: "" + e.data.client_company_id } })
                        }else if (e.column.colId === 'user' && this.$checkPermission(401)) {
                            this.$router.push({ name: 'user', params: { id: "" + e.data.user_id } })
                        }
                    },
                    onRowDataChanged: () => {
                        this.$nextTick(() => {
                            this.gridColumnApi.autoSizeColumns(this.totalColumnList);
                            if(this.columnsWidth < this.tableWidth){
                                this.gridApi.sizeColumnsToFit()
                            }
                        });
                        this.$nextTick(() => {
                            this.updatePerUserGraphData();
                        });
                        this.$nextTick(() => {
                            this.updatePerClientGraphData();
                        });
                    },
                    onFilterChanged: () => {
                        this.$nextTick(() => {
                            this.updatePerUserGraphData();
                        });
                        this.$nextTick(() => {
                            this.updatePerClientGraphData();
                        });
                    }
                },
                maxPageNumbers: 7,
                gridApi: null,
                gridColumnApi: null,
                defaultColDef: {
                    sortable: true,
                    editable: false,
                    resizable: true,
                    suppressMenu: true,
                    filterParams: { newRowsAction: 'keep'}
                },
                columnDefs: [
                    {
                        headerName: "ID",
                        field: 'company_task_id',
                        filter: true,
                        width: 50
                    },
                    {
                        headerName: this.$t("Client"),
                        field: 'client_company',
                        filter: true,
                    },
                    {
                        headerName: this.$t("TaskTitle"),
                        field: 'task_title',
                        filter: true,
                        cellRendererFramework: TaskNameRenderer,
                    },
                    {
                        headerName: this.$t("WorkType"),
                        field: 'work_type',
                        filter: true,
                    },
                    {
                        headerName: this.$t("User"),
                        field: 'user',
                        filter: true,
                    },
                    {
                        headerName: this.$t("EndTime"),
                        field: 'end_time',
                        filter: true,
                        width: 150,
                        cellRendererFramework: TimeRenderer,
                    },
                    {
                        headerName: this.$t("TotalTime"),
                        field: 'total_time',
                        filter: true,
                    },
                    {
                        headerName: this.$t("NonInvoicedTime"),
                        field: 'non_invoiced_time',
                        filter: true,
                    },
                    {
                        headerName: this.$t("Tags"),
                        field: 'tags_string',
                        filter: true,
                    },
                ],

                totalColumnList: [],

                perUserGraphData: [],
                perUserGraphOptions: {},
                perUserGraphHeight: 100,

                perClientGraphData: [],
                perClientGraphOptions: {},
                perClientGraphHeight: 100,

            }
        },
        watch: {
            '$store.state.windowWidth'(val) {
                if(val <= 576) {
                    this.maxPageNumbers = 4;
                    this.gridOptions.columnApi.setColumnPinned('title', null)
                }
                else this.gridOptions.columnApi.setColumnPinned('title', 'left')
            },
        },
        computed: {
            totalTime() {

                if(!this.gridApi) return 0;

                let time = 0;

                for(let x = 0; x < this.gridApi.getDisplayedRowCount(); x++){
                    time += Number(this.gridApi.getDisplayedRowAtIndex(x).data.total_time);
                }

                return time;

            },
            nonInvoicedTime() {

                if(!this.gridApi) return 0;

                let time = 0;

                for(let x = 0; x < this.gridApi.getDisplayedRowCount(); x++){
                    time += Number(this.gridApi.getDisplayedRowAtIndex(x).data.non_invoiced_time);
                }

                return time;

            },
            currentPage: {
                get() {
                    if(this.gridApi) return this.gridApi.paginationGetCurrentPage() + 1
                    else return 1
                },
                set(val) {
                    if(this.gridApi){
                        this.gridApi.paginationGoToPage(val - 1)
                    }

                }
            },
            columnsWidth() {
                let total = 0;
                let state = this.gridColumnApi.getColumnState();
                if(state){
                    for(let x = 0; x < state.length; x++){
                        total += state[x].width
                    }
                }

                return total;
            },
            tableWidth() {
                return this.gridApi.gridPanel.eBodyViewport.clientWidth;
            },
            paginationPageSize() {
                if(this.gridApi) return this.gridApi.paginationGetPageSize();
                else return 50
            },
            totalPages() {
                if(this.gridApi) return this.gridApi.paginationGetTotalPages();
                else return 0
            },
            usersArray() {
                if(!this.$store.getters.companyUsers) return null;

                let data = [];
                for (let key in this.$store.getters.companyUsers) {
                    if (this.$store.getters.companyUsers.hasOwnProperty(key)){
                        if(this.$store.getters.companyUsers){
                            data.push(this.$store.getters.companyUsers[key])
                        }
                    }
                }

                return data;
            },
            clientsArray() {
                if(!this.$store.getters.companyClients) return null;

                let data = [];
                for (let key in this.$store.getters.companyClients) {
                    if (this.$store.getters.companyClients.hasOwnProperty(key)){
                        if(this.$store.getters.companyClients){
                            data.push(this.$store.getters.companyClients[key])
                        }
                    }
                }

                return data;
            },
        },
        methods: {
            resizeColumns(){
                this.gridColumnApi.autoSizeColumns(this.totalColumnList);
                if(this.columnsWidth < this.tableWidth){
                    this.gridApi.sizeColumnsToFit()
                }
            },
            updateSearchQuery(val) {
                this.gridApi.setQuickFilter(val)
            },
            clearFilters(){
                this.gridApi.setFilterModel(null);
            },
            clearOptions(){

                if(this.clientsArray){
                    for(let x = 0; x < this.clientsArray.length; x++){
                        this.selectedClients.push(this.clientsArray[x])
                    }
                }

                if(this.usersArray){
                    for(let x = 0; x < this.usersArray.length; x++){
                        this.selectedUsers.push(this.usersArray[x])
                    }
                }

                if(this.$store.state.tagsArray){
                    for(let x = 0; x < this.$store.state.tagsArray.length; x++){
                        this.selectedTags.push(this.$store.state.tagsArray[x])
                    }
                }

                this.reqOptions.untagged = true;
                this.reqOptions.projects = 0;
                this.reqOptions.start_time = new Date();
                this.reqOptions.end_time = new Date();
            },
            loadData(){

                this.$vs.loading({
                    background: "primary",
                    color: "fff",
                    container: "#getDataDiv",
                    scale: 1
                });

                let tags = [];
                for(let x = 0; x < this.selectedTags.length; x++){
                    tags.push(this.selectedTags[x].id)
                }

                let users = [];
                for(let x = 0; x < this.selectedUsers.length; x++){
                    users.push(this.selectedUsers[x].id)
                }

                let clients = [];
                for(let x = 0; x < this.selectedClients.length; x++){
                    clients.push(this.selectedClients[x].id)
                }

                const thisIns = this;
                this.$http.post('/api/v1/analytics/times', {
                    start_time: thisIns.moment(thisIns.reqOptions.start_time).format(),
                    end_time: thisIns.moment(thisIns.reqOptions.end_time).add(1, 'd').subtract(1, 'ms').format(),
                    tags: tags,
                    company_users: users,
                    client_companies: clients,
                    projects: Number(thisIns.reqOptions.projects),
                    untagged: thisIns.reqOptions.untagged
                }).then(function (response) {
                    thisIns.times = response.data;
                    thisIns.$vs.loading.close("#getDataDiv > .con-vs-loading");
                }).catch(function (error) {
                    thisIns.$vs.loading.close("#getDataDiv > .con-vs-loading");
                    thisIns.$vs.notify({
                        title:'Error',
                        text: error.response.data,
                        color:'danger',
                        iconPack: 'feather',
                        icon:'icon-alert-circle'})
                });

            },
            async updatePerUserGraphData(){
                if(!this.gridApi) return 0;

                let dataByUser = {};
                let finalData = [];

                let users = [];
                let userCategories = [];

                let addedWorkTypes = [];
                let workTypes = [];

                for(let x = 0; x < this.gridApi.getDisplayedRowCount(); x++){

                    let currentNode = this.gridApi.getDisplayedRowAtIndex(x).data;

                    if(!addedWorkTypes.includes(currentNode.work_type_id)) {
                        addedWorkTypes.push(currentNode.work_type_id);
                        workTypes.push({
                            name: currentNode.work_type,
                            id: currentNode.work_type_id
                        })
                    }

                    if(dataByUser.hasOwnProperty(currentNode.user_id)){

                        if(dataByUser[currentNode.user_id].data.hasOwnProperty(currentNode.work_type_id)){
                            dataByUser[currentNode.user_id].data[currentNode.work_type_id] += Number(currentNode.total_time) - Number(currentNode.non_invoiced_time)
                        }else{
                            dataByUser[currentNode.user_id].data[currentNode.work_type_id] = Number(currentNode.total_time) - Number(currentNode.non_invoiced_time)
                        }


                    }else{
                        dataByUser[currentNode.user_id] = {
                            name: currentNode.user,
                            data: {}
                        };

                        users.push({
                            name: currentNode.user,
                            id: currentNode.user_id
                        });

                        userCategories.push(currentNode.user);

                        dataByUser[currentNode.user_id].data[currentNode.work_type_id] = Number(currentNode.total_time) - Number(currentNode.non_invoiced_time)

                    }
                }

                for(let x = 0; x < workTypes.length; x++) {

                    finalData.push({
                        name: workTypes[x].name,
                        data: []
                    });

                    for(let y = 0; y < users.length; y++){

                        if(dataByUser[users[y].id].data.hasOwnProperty(workTypes[x].id)){
                            finalData[x].data.push(dataByUser[users[y].id].data[workTypes[x].id])
                        }else{
                            finalData[x].data.push(0)
                        }

                    }

                }

                this.perUserGraphData = finalData;
                this.perUserGraphHeight = userCategories.length * 50 + 100;
                this.perUserGraphOptions = {
                    grid: {
                        borderColor: '#ebebeb',
                        padding: {
                            left: 0,
                            right: 0
                        }
                    },
                    dataLabels: {
                        enabled: false
                    },
                    chart: {
                        stacked: true,
                        type: 'bar',
                    },
                    plotOptions: {
                        bar: {
                            horizontal: true,
                        }
                    },
                    xaxis: {
                        categories: userCategories,
                        axisBorder: {
                            show: false,
                        },
                    },
                    yaxis: {
                        labels: {
                            style: {
                                cssClass: 'text-grey fill-current',
                            }
                        }
                    },
                    tooltip: {
                        x: { show: false }
                    },
                    fill: {
                        opacity: 1
                    },
                    legend: {
                        position: 'top',
                        horizontalAlign: 'left',
                        offsetX: 40
                    }
                };

            },
            async updatePerClientGraphData(){
                if(!this.gridApi) return 0;

                let dataByClient = {};
                let finalData = [];

                let clients = [];
                let clientCategories = [];

                let addedWorkTypes = [];
                let workTypes = [];

                for(let x = 0; x < this.gridApi.getDisplayedRowCount(); x++){

                    let currentNode = this.gridApi.getDisplayedRowAtIndex(x).data;

                    if(!addedWorkTypes.includes(currentNode.work_type_id)) {
                        addedWorkTypes.push(currentNode.work_type_id);
                        workTypes.push({
                            name: currentNode.work_type,
                            id: currentNode.work_type_id
                        })
                    }

                    if(dataByClient.hasOwnProperty(currentNode.client_company_id)){

                        if(dataByClient[currentNode.client_company_id].data.hasOwnProperty(currentNode.work_type_id)){
                            dataByClient[currentNode.client_company_id].data[currentNode.work_type_id] += Number(currentNode.total_time) - Number(currentNode.non_invoiced_time)
                        }else{
                            dataByClient[currentNode.client_company_id].data[currentNode.work_type_id] = Number(currentNode.total_time) - Number(currentNode.non_invoiced_time)
                        }


                    }else{
                        dataByClient[currentNode.client_company_id] = {
                            name: currentNode.user,
                            data: {}
                        };

                        clients.push({
                            name: currentNode.client_company,
                            id: currentNode.client_company_id
                        });

                        clientCategories.push(currentNode.client_company);

                        dataByClient[currentNode.client_company_id].data[currentNode.work_type_id] = Number(currentNode.total_time) - Number(currentNode.non_invoiced_time)

                    }
                }

                for(let x = 0; x < workTypes.length; x++) {

                    finalData.push({
                        name: workTypes[x].name,
                        data: []
                    });

                    for(let y = 0; y < clients.length; y++){

                        if(dataByClient[clients[y].id].data.hasOwnProperty(workTypes[x].id)){
                            finalData[x].data.push(dataByClient[clients[y].id].data[workTypes[x].id])
                        }else{
                            finalData[x].data.push(0)
                        }

                    }

                }

                this.perClientGraphData = finalData;
                this.perClientGraphHeight = clientCategories.length * 50 + 100;
                this.perClientGraphOptions = {
                    grid: {
                        borderColor: '#ebebeb',
                        padding: {
                            left: 0,
                            right: 0
                        }
                    },
                    dataLabels: {
                        enabled: false
                    },
                    chart: {
                        stacked: true,
                        type: 'bar',
                    },
                    plotOptions: {
                        bar: {
                            horizontal: true,
                        }
                    },
                    xaxis: {
                        categories: clientCategories,
                        axisBorder: {
                            show: false,
                        },
                    },
                    yaxis: {
                        labels: {
                            style: {
                                cssClass: 'text-grey fill-current',
                            }
                        }
                    },
                    tooltip: {
                        x: { show: false }
                    },
                    fill: {
                        opacity: 1
                    },
                    legend: {
                        position: 'top',
                        horizontalAlign: 'left',
                        offsetX: 40
                    }
                };

            }
        },
        created() {
            let currentTime = new Date();
            this.reqOptions.start_time = new Date(currentTime.getFullYear(), currentTime.getMonth(), currentTime.getDate());;
            this.reqOptions.end_time = new Date(currentTime.getFullYear(), currentTime.getMonth(), currentTime.getDate());;

            if(this.clientsArray){
                for(let x = 0; x < this.clientsArray.length; x++){
                    this.selectedClients.push(this.clientsArray[x])
                }
            }

            if(this.usersArray){
                for(let x = 0; x < this.usersArray.length; x++){
                    this.selectedUsers.push(this.usersArray[x])
                }
            }

            if(this.$store.state.tagsArray){
                for(let x = 0; x < this.$store.state.tagsArray.length; x++){
                    this.selectedTags.push(this.$store.state.tagsArray[x])
                }
            }

        },
        mounted() {
            this.gridApi = this.gridOptions.api;
            this.gridColumnApi = this.gridOptions.columnApi;
            this.totalColumnList = [];
            for(let x = 0; x < this.gridColumnApi.columnController.columnDefs.length; x++){
                this.totalColumnList.push(this.gridColumnApi.columnController.columnDefs[x].field);
            }
        },
    }

</script>
